import React from 'react'

import Home from './home/container'
import Imagens from './imagens/container'
import PaginaEditor from './editor/container'
import NotFoundYet from './404'
import Vendas from './vendas/container'
import Corretores from './corretores/container'
import Header from './header/container'
import {Redirect} from 'react-router-dom'



import './style.css'
import { Route, Link, Switch } from "react-router-dom";




export default (props) =>{

    let {auth} = props;

    console.log(props,'**administrativo')
    
    if(auth!==undefined)
        return(<div className='administrative_page'>
        
            <div className='content_container'>
                <Header history={props.history}/>
                <Switch>
                    <Route path="/adm" exact component={Home}/>
                    <Route path="/adm/imagenslocais" component={Imagens} />
                    <Route path="/adm/paginas/:paginaId" component={PaginaEditor} />
                    <Route path="/adm/mapa" component={Vendas} />
                    <Route path="/adm/corretores" component={Corretores} />
                    <Route component={NotFoundYet} />
                </Switch>
                
            </div>
        </div>
        )
    else {
        return <Redirect to='/login'/>
    }
}


// WEBPACK FOOTER //
// ./src/views/administrativo/component.js